<template>
  <layout>
    <img
      v-if="logo !== null"
      class="mx-auto my-6 h-10 w-20 w-auto"
      :src="logo"
      alt="broker logo"
    />
    <h1 class="header-text">
      {{ getTitle(messageId) }}
    </h1>
    <p class="mb-6 text-dark-gray">
      {{ selectMessage(messageId) }}
    </p>
    <!-- In option two a line break is made, the following condition facilitates how it will look like. -->
    <p
      v-if="messageId === 2"
      class="my-4"
    >
      In the meantime, you can add more Carriers within your Dispatcher Portal.
      For help, please call 906-Highway or email us at service@highway.com.
    </p>
    <button-main @click="$router.push('/dispatcher')">
      Go to Dispatcher Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
  </layout>
</template>

<script>
import Button from '../Button.vue';
import Layout from '../layouts/HoldingTankLayout.vue';

export default {
  name: 'Held For Carrier Approval',
  components: {
    'button-main': Button,
    Layout,
  },
  props: {
    companyType: String,
    companyName: String,
    loading: Boolean,
    failedRules: Array,
    incompleteRules: Array,
    totalRules: Number,
    rulesSyntax: Object,
    supportEmail: String,
    brokerLogo: String,
    statusCode: Number,
  },
  data() {
    return {
      messageId: null,
      logo: null,
    };
  },
  async created() {
    const id = this.$route.params.messageId;
    this.messageId = Number(id);
  },
  async mounted() {
    const clientLogo = await this.$store.dispatch(
      'brokers/getLogoByClientId',
      localStorage.getItem('client_id')
    );
    if (clientLogo.status === 200) {
      this.logo = clientLogo?.data?.url;
      console.log(this.logo);
    }
    let body = {
      carrier_id: localStorage.getItem('carrier_detail_id'),
      client_id: localStorage.getItem('client_id'),
    };
    const res = await this.$store.dispatch(
      'onboardingPacket/createDispatcherOnBoardingPacket',
      body
    );
    let redirectAfterSignIn = JSON.parse(
      localStorage.getItem('redirect_url_after_sigin')
    );
    if (redirectAfterSignIn && res.status !== 422) {
      // Set the state.dispatchers.selectedCarrierId before
      // going back to OAuth screen in this special use case
      // where they chose the carrier when they signed up
      await this.$store.commit(
        'dispatchers/setSelectedCarrierId',
        localStorage.getItem('carrier_detail_id')
      );
      localStorage.removeItem('redirect_url_after_sigin');
      localStorage.removeItem('carrier_detail_id');

      this.$router.push(redirectAfterSignIn);
    }
  },
  methods: {
    selectMessage(id) {
      switch (id) {
        case 1:
          return "But we want to get you back on track! Email us at service@highway.com, or just call us at 1-906-HIGHWAY (1-906-444-4929) for help. We're available on weekdays from 8am-5pm CT.";
        case 2:
          return "The carrier's authorized representatives received an email asking them to approve your relationship. You will receive an email when the request is approved so that you can continue onboarding this carrier.";
        case 3:
          return 'A representative of [carrier name] has declined your request to connect on Highway. If you feel this was an error, please follow up with representatives of the carrier or contact service@highway.com for help.';
        default:
          break;
      }
    },
    getTitle(id) {
      switch (id) {
        case 1:
          return 'Hmm...someting went wrong...';
        case 2:
          return 'Awaiting Approval...';
        case 3:
          return 'Request Declined';
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
.text-link {
  color: #e7b812;
}

.link-icon {
  position: relative;
  bottom: 1px;
}
</style>
